/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-12-08 00:00:00
 *
 *******************************************************/
// @flow
import React, { useState, useCallback } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { TickSmallMinor } from '@shopify/polaris-icons';

const FilterActionList = (props: WithI18nProps) => {
  const { i18n, selected = 'any' } = props;

  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive(active => !active), []);

  // Update state when changing option
  const handleSearchAny = useCallback(() => {
    props.onSelect('any');
    toggleActive();
  }, [props, toggleActive]);

  const handleSearchComplete = useCallback(() => {
    props.onSelect('complete');
    toggleActive();
  }, [props, toggleActive]);

  const handleSearchMissing = useCallback(() => {
    props.onSelect('missing');
    toggleActive();
  }, [props, toggleActive]);

  const activator = (
    <Button onClick={toggleActive} disclosure>
      {i18n.translate('AdminHTML.SwatchSettings.SwatchSettings.searchActionLabel')}
    </Button>
  );

  return (
    <div className="swatchActionList">
      <Popover active={active} activator={activator} onClose={toggleActive}>
        <ActionList
          sections={[
            {
              title: i18n.translate('AdminHTML.SwatchSettings.SwatchSettings.searchNote'),
              items: [
                {
                  content: i18n.translate('AdminHTML.SwatchSettings.SwatchSettings.searchLabelAny'),
                  suffix: selected === 'any' && <Icon source={TickSmallMinor} />,
                  active: selected === 'any',
                  onAction: handleSearchAny
                },
                {
                  content: i18n.translate(
                    'AdminHTML.SwatchSettings.SwatchSettings.searchLabelComplete'
                  ),
                  suffix: selected === 'complete' && <Icon source={TickSmallMinor} />,
                  active: selected === 'complete',
                  onAction: handleSearchComplete
                },
                {
                  content: i18n.translate(
                    'AdminHTML.SwatchSettings.SwatchSettings.searchLabelMissing'
                  ),
                  suffix: selected === 'missing' && <Icon source={TickSmallMinor} />,
                  active: selected === 'missing',
                  onAction: handleSearchMissing
                }
              ]
            }
          ]}
        />
      </Popover>
    </div>
  );
};

export default withI18n()(FilterActionList);
